import SidebarCollapse from "@builder/components/app/SidebarCollapse";
import { EditableProps } from "@builder/components/editable/editableProps";
import OliverText from "@builder/components/general/OliverText";
import "./style.scss";
import { useAppDispatch, useAppSelector } from "@builder/store/store";
import { getSelectedNode } from "@builder/store/slices/BuilderSlice/builderSelectors";
import { GlobalBlockTypes, PrintButtonNode } from "@common/build/types";
import AltSelectInput from "@builder/components/general/AltSelectInput";
import { attachGlobalBlock, detachGlobalBlock } from "@builder/store/slices/BuilderSlice/builderSlice";
import { useGetGlobalBlocksQuery } from "@builder/store/slices/BuildsApiSlice/buildsApiSlice";
import { skipToken } from "@reduxjs/toolkit/query";
import { useMemo } from "react";

const Printer = ({ parent }: EditableProps) => {
    const dispatch = useAppDispatch();
    const selectedNode = useAppSelector(getSelectedNode) as PrintButtonNode;
    const globalBlock = useAppSelector(state => state.builder.build.globalBlocks?.[selectedNode?.globalBlock || ""]);
    // const companyId = useAppSelector(state => state.storeData?.company?._id);
    const companyId = useAppSelector(state => state.builder.build.companyId);

    const { data: printBlocks } = useGetGlobalBlocksQuery(
        companyId && GlobalBlockTypes.GB_PRINT ? { companyId, gbType: GlobalBlockTypes.GB_PRINT } : skipToken
    );

    const printBlockOptions = useMemo(() => {
        if (printBlocks) {
            return printBlocks.map((block: any) => ({
                id: block._id,
                name: block.name
            }));
        }
        return [];
    }, [printBlocks]);

    console.log("printBlocks", printBlocks);

    const printBlockCallback = (option: { name: string; id: string }) => {
        if (option.id === "default") {
            dispatch(detachGlobalBlock(selectedNode?.globalBlock || ""));
        } else {
            dispatch(attachGlobalBlock({ id: option.id, name: option.name }));
        }
    };

    return (
        <SidebarCollapse title="Printer Setup" parent={parent}>
            <OliverText text="Select print block" size="xs" translatePrefix="editable.printer." />
            <OliverText
                text="The block you select will be printed on the printer you select."
                size="xxs"
                className="print-block-subtext"
                translatePrefix="editable.printer."
            />
            <AltSelectInput
                selected={globalBlock?.name || "Default"}
                options={[{ id: "default", name: "Default" }, ...(printBlockOptions || [])]}
                getLabel={option => option.name}
                callback={printBlockCallback}
            />
        </SidebarCollapse>
    );
};

export default Printer;
